import {
  ImageBackground,
  TouchableOpacity,
  Image,
  Text,
  StyleSheet,
} from "react-native";
import { ToggleBgPng, ToggleKnobPng } from "../../../assets";

export const RenderToggle = ({
  value,
  onChange,
}: {
  value: boolean;
  onChange: () => void;
}) => (
  <TouchableOpacity onPress={onChange} activeOpacity={0.8}>
    <ImageBackground
      source={ToggleBgPng}
      style={styles.toggleBg}
      resizeMode="stretch"
      imageStyle={styles.toggleBgImage}
    >
      <Image
        source={ToggleKnobPng}
        style={[styles.knob, { left: value ? 60 : 2 }]}
      />
      <Text style={styles.knobLabel}>{value ? "On" : "Off"}</Text>
    </ImageBackground>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  toggleBg: {
    width: 90,
    height: 40,
    justifyContent: "center",
  },
  toggleBgImage: {
    borderRadius: 25,
  },
  knob: {
    position: "absolute",
    width: 28,
    height: 28,
    top: 5,
  },
  knobLabel: {
    alignSelf: "center",
    fontSize: 16,
    fontWeight: "500",
    color: "#fff",
  },
});
